<template>
    <v-navigation-drawer
        :value="navDrawer"
        app
        fixed
        disable-resize-watcher
        expand-on-hover
        :clipped="$vuetify.breakpoint.lgAndUp"
    >
        <v-list>
            <v-list-item
                v-for="item in sidebarItems"
                :key="item.title"
                :disabled="item.disabled"
                :aria-current="$route.path === item.route ? 'page' : false"
                @click.stop="onNavigationClick(item)"
            >
                <v-list-item-action class="mr-5 my-2">
                    <v-icon large :color="item.disabled ? 'grey' : 'primary'">{{
                        itemIcon(item)
                    }}</v-icon>
                </v-list-item-action>

                <v-list-item-content
                    :class="[item.disabled ? 'grey--text' : 'primary--text']"
                >
                    <v-list-item-title class="font-weight-medium">{{
                        item.title
                    }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AppSidebar',
    computed: {
        ...mapState(['navDrawer', 'sidebarItems']),
        ...mapState('authUser', ['userToken'])
    },
    methods: {
        itemIcon(item) {
            if (item && item.icon && this.icons[item.icon]) {
                return this.icons[item.icon];
            } else {
                return this.icons['defaultNav'];
            }
        },
        onNavigationClick(item) {
            if (item.route) {
                this.$router.push(item.route).catch(() => {});
            } else if (item.href) {
                let url = item.href;
                if (item.appendToken) {
                    url = `${url}/?user_token=${this.userToken}`;
                }
                document.location.href = url;
            }
        }
    }
};
</script>

<style scoped lang="scss"></style>
